import React from "react";
import ArtDecoDivider from "./ArtDecoDivider";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-obsidian-deep border-t border-white/5 mt-24"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16 text-center">
                <div className="font-display text-2xl md:text-3xl text-white tracking-wide">
                    The <em className="gold-italic">Spirited</em> Gentleman
                </div>
                <ArtDecoDivider />
                <p className="text-white/60 font-sans text-sm tracking-wide">
                    Bespoke mobile bartending for distinguished gatherings.
                </p>
                <a
                    href="mailto:TheSpiritedGent@gmail.com"
                    data-testid="footer-email-link"
                    className="inline-block mt-6 text-gold text-sm tracking-widest uppercase border-b border-gold/40 pb-1 hover:border-gold transition-colors"
                >
                    TheSpiritedGent@gmail.com
                </a>
                <div className="mt-12 text-xs tracking-overline uppercase text-white/30">
                    © {new Date().getFullYear()} The Spirited Gentleman · Reservation by invitation
                </div>
            </div>
        </footer>
    );
}
